<template>
    <div class="record-report-container">
        <div class="t-top-bar">
            <div class="report-op">
                <el-input placeholder="员工编号、员工姓名" v-model="keyword" class="search-input"></el-input>
                <el-cascader class="search-input sd" clearable v-model="searchDepart" placeholder="所属班组" :options="treeData"
                             :props="{ expandTrigger: 'hover', label: 'name',value:'departmentId' }" @change="treeChange"></el-cascader>
<!--              <el-select  class="search-input200" clearable v-model="selectColumn" placeholder="统计数据">-->
<!--                <el-option v-for="(val,key, i) in reportColumn" :key="i" :label="val" :value="key"></el-option>-->
<!--              </el-select>-->
              <el-select  class="search-input200" clearable v-model="pn">
                <el-option v-for="(val,key, i) in pns" :key="i" :label="val" :value="key"></el-option>
              </el-select>
                <el-date-picker  v-model="selectTime" type="daterange" :picker-options="pickerOptions"
                        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                        align="right"></el-date-picker>
            </div>
            <div class="report-op"><el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button></div>
            <div class="report-op"><el-button style="margin: 0" type="primary"  @click="print">打印</el-button></div>
            <div class="report-op"><i class="el-icon-download l-add-buttion" @click="exportExcel"></i></div>
        </div>
        <el-table id="printTable" :data="tableData" border style="width: 100%"  height="640" v-loading="listLoading">
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column prop="staff_no" label="工号" width="100"></el-table-column>
          <el-table-column prop="staff_name" label="员工名称" width="100"></el-table-column>
          <el-table-column v-for="(item, i) in tableHead" :prop="item.prop" :label="item.name" :key="i" min-width="120">
            <template slot-scope="scope">
              {{ showdata(scope.row, item)}}
            </template>
          </el-table-column>
          <el-table-column prop="sumPrice" width="180" label="合计">
            <template slot-scope="scope">
              {{ (scope.row.sumPrice).toFixed(2)}}
            </template>
          </el-table-column>
          <el-table-column prop="suelSubsidy" label="燃油补助"></el-table-column>
          <el-table-column prop="salarySubsidy"  width="180" label="工资补助">
            <template slot-scope="scope">
              {{ (calcSalarySubsidy(scope.row.sumPrice)).toFixed(2)}}
            </template>
          </el-table-column>
          <el-table-column prop="total"  width="180" label="总计">
            <template slot-scope="scope">
              {{ (calcSalarySubsidy(scope.row.sumPrice) + scope.row.sumPrice+scope.row.suelSubsidy).toFixed(2) }}
            </template>
          </el-table-column>
<!--          <el-table-column prop="total_price" label="总价(元)" width="100"></el-table-column>-->
        </el-table>
    </div>
</template>

<script>
    import { getRecordListPrice } from '../../api/record'
    import {dataprint, tableDataToExcel, tableDataToExcelV1} from '../../util/util'
    import { getEquipmentListAll } from '../../api/equipment'
    import { getDepartmentList } from '../../api/department'
    import localCache from "../../util/localCache";
    export default {
        name: "yuxiangSalaryReport",
        data(){
          function calcSalarySubsidy(sumPrice){
            if(sumPrice >= 5000){
              return sumPrice * 0.1
            }else if(sumPrice >= 4000){
              return sumPrice * 0.09
            }else if(sumPrice >= 3000){
              return sumPrice * 0.08
            }else if(sumPrice >= 2000){
              return sumPrice * 0.07
            }else {
              return 0
            }
          }
            return {
                listLoading: false,
                tableHead: [],
                tableData: [],
                reportColumn: {
                  'total_price': '工资',
                  // 'calc_kg': '计价重量',
                  // 'delivery_kg': '交料重量'
                },
                selectColumn: 'total_price',
                pns:{
                  '剥虾':'剥虾',
                  '去头':'去头'
                },
                pn: '剥虾',
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                selectTime: '',
                keyword: '',
                exportColumn: {

                },
                exportColumn0: {
                  'staff_no': {
                    title: '员工编号'
                  },
                  'staff_name': {
                    title: '员工名称'
                  }
                },
              exportColumn1: {
                'sumPrice': {
                  title: '合计'
                },
                'suelSubsidy': {
                  title: '燃油补助'
                },
                'salarySubsidy': {
                  title: '工资补助',
                  fk(val,row){
                    return (calcSalarySubsidy(row.sumPrice)).toFixed(2)
                  }
                },
                'total': {
                  title: '总计',
                  fk(val,row){
                    return (calcSalarySubsidy(row.sumPrice) + row.sumPrice+row.suelSubsidy).toFixed(2)
                  }
                }
              },
                subEquipments: [],
                subEquipmentId:'',
                searchDepart:'',
                treeData: [],
                priceType:''
            }
        },
        mounted(){
            let now = new Date()
            let end = new Date(now.getFullYear(),now.getMonth(),now.getDate(),0,0).getTime();
            let begin = end - 86400000 * (now.getDate()-1);
            let start = new Date(begin)
            this.selectTime = [start,now]

            this.refreshHead(begin, end)
            this.getRecordList_()
            this.getTree()
        },
        methods: {
          print(){
            var printHTML = document.getElementById('printTable').innerHTML; // 获取要打印的内容
            dataprint(printHTML)
          },
            refreshHead(begin, end) {
              this.tableHead = []
              this.exportColumn = JSON.parse(JSON.stringify(this.exportColumn0))
              for (let i = begin; i <= end; i+= 86400000) {
                let date = new Date(i);
                let day = date.getDate();
                let o = {
                  prop: `m${date.getMonth()+1}d${day}`,
                  name: `${day}日`,
                  day: day,
                  month: date.getMonth()
                }
                this.tableHead.push(o)
                this.exportColumn[o.prop] = {
                  title: o.name,
                  childs: {
                    [this.selectColumn]: this.reportColumn[this.selectColumn]
                  }
                }
              }
              Object.assign(this.exportColumn, this.exportColumn1)
            },
            exportExcel(){
                let depart = document.querySelector('.sd').querySelector('input').value || ''
                let date = new Date(this.selectTime[0])
                let title = `${depart}${date.getFullYear()}年${date.getMonth()+1}月份计件工资表(${this.pn})`
                tableDataToExcelV1(this.tableData,title,this.exportColumn,'0',{
                  showTitle: true
                })
            },
            search(){
                this.getRecordList_()
            },
            getRecordList_(){
                if(!this.selectTime){
                    this.$message.error('请选择开始结束时间')
                    return
                }
                this.listLoading = true
                let departmentId = ''
                if(this.searchDepart){
                    departmentId = this.searchDepart[this.searchDepart.length-1]
                }
                let param = {
                  customerId: localCache.getCurrentCustomerId(),
                  beginTime: parseInt(this.selectTime[0].getTime()/1000),
                  endTime: parseInt(this.selectTime[1].getTime()/1000),
                  keyword: this.keyword,
                  departmentId:departmentId,
                  pn: this.pn
                }
                if(param.beginTime == param.endTime){
                  param.endTime += 86400
                }
                getRecordListPrice(param).then(res => {
                    this.listLoading = false
                    if (res.errorcode !== 0) {
                        this.$message.error(res.message)
                    } else {
                        this.refreshHead(this.selectTime[0].getTime(), this.selectTime[1].getTime())
                        this.tableData = this.parseData(res.data)
                        console.log(this.tableData)
                    }
                }).catch(() => {
                    this.listLoading = false
                })
            },
            parseData(data){
              let t
              let d = []
              let o = {}
              let totalrow = {
                staff_no: '小计',
                staff_name: '',
                sumPrice: 0,
                suelSubsidy: 0
              }
              for (let i = 0,len = data.length; i < len; i++) {
                t = data[i]
                let key = t.staff_no
                let daySalary = t.total_price?t.total_price:0
                if(!o[key]){
                  o[key] = {
                    staff_no: t.staff_no,
                    staff_name: t.staff_name,
                    sumPrice: daySalary,
                    suelSubsidy: this.calcSuelSubsidy(daySalary)
                  }
                  d.push(o[key])
                }else{
                  o[key].sumPrice += daySalary
                  o[key].suelSubsidy += this.calcSuelSubsidy(daySalary)
                }
                o[key][`m${t.month}d${t.day}`] = {
                  total_price: daySalary,
                }
                if(totalrow[`m${t.month}d${t.day}`] === undefined){
                  totalrow[`m${t.month}d${t.day}`] = {
                    total_price: 0,
                  }
                }
                totalrow[`m${t.month}d${t.day}`].total_price = totalrow[`m${t.month}d${t.day}`].total_price + daySalary
                totalrow.sumPrice = totalrow.sumPrice + daySalary
                totalrow.suelSubsidy = totalrow.suelSubsidy +  this.calcSuelSubsidy(daySalary)
              }
              d.push(totalrow)
              return d
            },
          calcSuelSubsidy(daySalary) {
            if(daySalary >= 70){
              return 2
            }
            return 0
          },
          calcSalarySubsidy(sumPrice){
              if(sumPrice >= 5000){
                return sumPrice * 0.1
              }else if(sumPrice >= 4000){
                return sumPrice * 0.09
              }else if(sumPrice >= 3000){
                return sumPrice * 0.08
              }else if(sumPrice >= 2000){
                return sumPrice * 0.07
              }else {
                return 0
              }
          },
            showdata(row, item){
              let o = row[item.prop]
              if(o){
                return o[this.selectColumn]
              }
              return ''
            },
          treeChange(val){
              console.log(this.treeData)

          },
            getTree() {
                getDepartmentList({
                    customerId:localCache.getCurrentCustomerId()
                }).then(res => {
                    if (res.errorcode !== 0) {
                        this.$message.error(res.message)
                    } else {
                        this.treeData = res.data
                    }
                }).catch(() => {
                })
            },
        }
    }
</script>

<style lang="scss">
    .record-report-container{
        .t-top-bar{
            display: flex;
        }
        .report-op{
            margin-right: 15px;
        }
        .report-op:last-child{
            margin-left: auto;
        }
        .search-input{
            width: 250px;
            margin-right: 15px;
        }
        .search-input200{
            width: 200px;
            margin-right: 15px;
        }
        .el-table td{
            padding: 0;
        }
    }

</style>
